import React from "react";

import talentLenzOpportunityUseCasesLiveSessionPhoto from "../../images/talentlenz-opportunity-use-cases-live-session-photo.jpg";
import talentLenzOpportunityUseCasesLiveSessionPhotoWebp from "../../images/mentor.webp";
import talentLenzOpportunityUseCasesWallSign from "../../images/talentlenz-opportunity-use-cases-wall-sign.png";

import "./TalentLenzOpportunityUseCases.css";

const talentLenzOpportunityTypes = [
  {
    id: "vacancies",
    label: "Vacancies",
    tone: "blue",
  },
  {
    id: "learnerships",
    label: "Learnerships",
    tone: "pink",
  },
  {
    id: "bursaries",
    label: "Bursaries",
    tone: "blue",
  },
  {
    id: "placements",
    label: "Placements",
    tone: "pink",
  },
];

export default function TalentLenzOpportunityUseCases() {
  return (
    <section
      id="talentlenz-opportunity-use-cases"
      className="talentlenz-opportunity-use-cases"
      aria-labelledby="talentlenz-opportunity-use-cases-title"
    >
      <div className="talentlenz-opportunity-use-cases__inner">
        <div className="talentlenz-opportunity-use-cases__copy">
          <p className="talentlenz-opportunity-use-cases__eyebrow">
            Built for more than vacancies
          </p>

          <h2
            id="talentlenz-opportunity-use-cases-title"
            className="talentlenz-opportunity-use-cases__title"
            aria-label="One platform. Every kind of opportunity."
          >
            <span
              className="talentlenz-opportunity-use-cases__title-layout talentlenz-opportunity-use-cases__title-layout--side-by-side"
              aria-hidden="true"
            >
              One platform.
              <br />
              Every kind of
              <br />
              opportunity.
            </span>

            <span
              className="talentlenz-opportunity-use-cases__title-layout talentlenz-opportunity-use-cases__title-layout--portrait"
              aria-hidden="true"
            >
              One platform. Every kind
              <br />
              of opportunity.
            </span>

            <span
              className="talentlenz-opportunity-use-cases__title-layout talentlenz-opportunity-use-cases__title-layout--mobile"
              aria-hidden="true"
            >
              One platform.
              <br />
              Every kind of
              <br />
              opportunity.
            </span>
          </h2>

          <p
            className="talentlenz-opportunity-use-cases__description"
            aria-label="Use TalentLenz for vacancies, learnerships, bursaries, graduate programmes, placements and other application-based opportunities. Configure the context, evidence and assessment for each."
          >
            <span
              className="talentlenz-opportunity-use-cases__description-layout talentlenz-opportunity-use-cases__description-layout--desktop"
              aria-hidden="true"
            >
              Use TalentLenz for vacancies, learnerships, bursaries,
              <br />
              graduate programmes, placements and other application-
              <br />
              based opportunities. Configure the context, evidence
              <br />
              and assessment for each.
            </span>

            <span
              className="talentlenz-opportunity-use-cases__description-layout talentlenz-opportunity-use-cases__description-layout--landscape"
              aria-hidden="true"
            >
              Use TalentLenz for vacancies, learnerships,
              <br />
              bursaries, graduate programmes, placements
              <br />
              and other application-based opportunities.
            </span>

            <span
              className="talentlenz-opportunity-use-cases__description-layout talentlenz-opportunity-use-cases__description-layout--portrait"
              aria-hidden="true"
            >
              Use TalentLenz for vacancies, learnerships, bursaries, graduate
              <br />
              programmes, placements and other application-based opportunities.
            </span>

            <span
              className="talentlenz-opportunity-use-cases__description-layout talentlenz-opportunity-use-cases__description-layout--mobile"
              aria-hidden="true"
            >
              Vacancies, learnerships, bursaries, graduate
              <br />
              programmes, placements and other
              <br />
              application-based opportunities.
            </span>
          </p>
        </div>

        <figure className="talentlenz-opportunity-use-cases__media">
          <picture className="talentlenz-opportunity-use-cases__photo-picture">
            <source
              srcSet={talentLenzOpportunityUseCasesLiveSessionPhotoWebp}
              type="image/webp"
            />

            <img
              className="talentlenz-opportunity-use-cases__photo"
              src={talentLenzOpportunityUseCasesLiveSessionPhoto}
              alt="A group discussing an opportunity while a participant scans a QR code."
              width="1600"
              height="1200"
              loading="lazy"
              decoding="async"
              draggable="false"
            />
          </picture>

          <img
            className="talentlenz-opportunity-use-cases__wall-sign"
            src={talentLenzOpportunityUseCasesWallSign}
            alt=""
            width="900"
            height="260"
            aria-hidden="true"
            decoding="async"
            draggable="false"
          />
        </figure>

        <ul
          className="talentlenz-opportunity-use-cases__list"
          aria-label="Opportunity types supported by TalentLenz"
        >
          {talentLenzOpportunityTypes.map((opportunityType) => (
            <li
              key={opportunityType.id}
              className={`talentlenz-opportunity-use-cases__item talentlenz-opportunity-use-cases__item--${opportunityType.tone}`}
            >
              <span
                className="talentlenz-opportunity-use-cases__item-dot"
                aria-hidden="true"
              />

              <span className="talentlenz-opportunity-use-cases__item-label">
                {opportunityType.label}
              </span>
            </li>
          ))}
        </ul>

        <p className="talentlenz-opportunity-use-cases__closing-note">
          If people apply, TalentLenz can structure the evidence.
        </p>
      </div>
    </section>
  );
}